import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userPermissions, setUserPermissions] = useState([]);
    const [country, setCountry] = useState("")
    const [customer, setCustomer] = useState(null);
    const [isCustomerLoggedIn, setIsCustomerLoggedIn] = useState(false)
    return (
        <UserContext.Provider value={{
            currentUser, setCurrentUser,
            isLoggedIn, setIsLoggedIn,
            userPermissions, setUserPermissions,
            country, setCountry,
            isCustomerLoggedIn, setIsCustomerLoggedIn,
            customer, setCustomer,
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
